/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Drawer_DescriptionInputs */



/**
* | output |
* | --- |
* | "Set every capability for this subject in one place. Inherited options fall back to the organization default only — team grants or floors a user inherits are ..." |
*
* @param {Rights_Drawer_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_drawer_description = /** @type {((inputs?: Rights_Drawer_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Drawer_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Berechtigungen für dieses Subjekt an einem Ort festlegen. Geerbte Optionen fallen nur auf den Org-Standard zurück – Team-Gewährungen oder -Sperren, die ein Nutzer erbt, sind nicht berücksichtigt; der effektive Zugriff kann abweichen.")
	return /** @type {LocalizedString} */ ("Set every capability for this subject in one place. Inherited options fall back to the organization default only — team grants or floors a user inherits are not reflected, so effective access can differ.")
});